_ = require('lodash')

PlayersAnalysisCtrl = ($scope, $routeParams) ->
  $scope.players = $scope.$parent.roundInfo.players
  $scope.specialMem = false
  $scope.activeTab = 0

  if $routeParams.user_id != undefined
    $scope.specialMem = true
  $scope.playerAnalysis = _.map $scope.$parent.playersAnalysis.players, (pa) ->
    # null * 100 -> 0, but we want to distinguish null from 0
    _.mapValues pa, (val) -> if _.isNull val then '-' else val

  $scope.activeDisplay = (tab) ->
    $scope.activeTab = tab
    return

  $scope.activeDisplay(0)


PlayersAnalysisCtrl.$inject = [
  '$scope'
  '$routeParams'
]

module.exports = PlayersAnalysisCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/players-analysis/players-analysis-controller.coffee